import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {
    ApplicationModel,
    ApplicationsSearchParams,
    ApplicationsViewType,
    CategoryHash,
    OrderCategory,
    OrderHistory,
    UpdateApplicationRequest
} from '../_common/models/order.models';

export const SetCategoriesSuccess = createAction(
    '[Applications] Set Categories Success',
    props<{ payload: OrderCategory[] }>()
);

export const SetCategoryHashesSuccess = createAction(
    '[Applications] Set Category Hashes Success',
    props<{ payload: CategoryHash[] }>()
);


// <editor-fold desc="Item">

export const LoadList = createAction(
    '[Applications] Load List',
    props<{ payload: { loading: DahLoadingType, viewType: ApplicationsViewType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Applications] Load List Success',
    props<{ payload: { items: ApplicationModel[], pagination: DahPaginationModel, viewType: ApplicationsViewType, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Applications] Load List Failure',
    props<{ payload: { error: HttpErrorResponse, viewType: ApplicationsViewType } }>()
);

export const SetPagination = createAction(
    '[Applications] Set Pagination',
    props<{ payload: { next: boolean, viewType: ApplicationsViewType } }>()
);

export const SetFilter = createAction(
    '[Applications] Set Filter',
    props<{ payload: { filter: ApplicationsSearchParams, viewType: ApplicationsViewType } }>()
);

export const SetLoading = createAction(
    '[Applications] Set Loading',
    props<{ payload: { loading: DahLoadingType, viewType: ApplicationsViewType } }>()
);

export const SetItemsLoading = createAction(
    '[Applications] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean, viewType: ApplicationsViewType } }>()
);

export const AddItemSuccess = createAction(
    '[Applications] Add Item Success',
    props<{ payload: { item: ApplicationModel } }>()
);

export const UpdateItemSuccess = createAction(
    '[Applications] Update Item Success',
    props<{ payload: { item: ApplicationModel } }>()
);

export const DeleteItem = createAction(
    '[Applications] Delete Item',
    props<{ payload: { item: ApplicationModel } }>()
);

export const DeleteItemSuccess = createAction(
    '[Applications] Delete Item Success',
    props<{ payload: { item: ApplicationModel } }>()
);

export const DeleteItemFailure = createAction(
    '[Applications] Delete Item Failure',
    props<{ payload: { item: ApplicationModel } }>()
);

// </editor-fold>


// <editor-fold desc="Comments">

export const LoadComments = createAction(
    '[Applications] Load Comments',
    props<{ payload: { itemId: string, next?: boolean } }>()
);

export const LoadCommentsSuccess = createAction(
    '[Applications] Load Comments Success',
    props<{ payload: { comments: OrderHistory[], pagination: DahPaginationModel, next?: boolean } }>()
);

export const LoadCommentsFailure = createAction(
    '[Applications] Load Comments Failure',
    props<{ error: HttpErrorResponse }>()
);

export const SendComment = createAction(
    '[Applications] Send Comment',
    props<{ payload: { applicationId: string, item: UpdateApplicationRequest } }>()
);

export const SendCommentSuccess = createAction(
    '[Applications] Send Comment Success',
    props<{ payload: { item: OrderHistory } }>()
);

export const SendCommentFailure = createAction(
    '[Applications] Send Comment Failure',
    props<{ error: HttpErrorResponse }>()
);

export const EditComment = createAction(
    '[Applications] Edit Comment',
    props<{ payload: { itemId: string, comment: string } }>()
);

export const EditCommentSuccess = createAction(
    '[Applications] Edit Comment Success',
    props<{ payload: { item: OrderHistory } }>()
);

export const EditCommentFailure = createAction(
    '[Applications] Edit Comment Failure',
    props<{ error: HttpErrorResponse }>()
);

export const DeleteComment = createAction(
    '[Applications] Delete Comment',
    props<{ payload: { itemId: string } }>()
);

export const DeleteCommentSuccess = createAction(
    '[Applications] Delete Comment Success',
    props<{ payload: { itemId: string } }>()
);

export const DeleteCommentFailure = createAction(
    '[Applications] Delete Comment Failure',
    props<{ error: HttpErrorResponse }>()
);

export const SetInitialCommentsState = createAction(
    '[Applications] Set Initial Comments State'
);

// </editor-fold>


export const SetInitialState = createAction(
    '[Applications] Set Initial State'
);
